<div class="h-full w-full overflow-y-auto p-6">
  <div class="text-2xl font-bold text-primary mb-4">MAIS Options</div>
  <div class="flex flex-col gap-4 mb-8">
    <div class="mi-input-label max-w-md">
      <label for="aiBaseUrl">MAIS API base URL</label>
      <input
        pInputText
        type="text"
        id="aiBaseUrl"
        [(ngModel)]="aiConfigService.config.baseUrl"
        [ngModelOptions]="{ standalone: true }"
        placeholder="http://localhost:3001/api"
        data-e2e="ai-base-url"
      />
    </div>
    <div class="mi-input-label max-w-md">
      <label for="aiWorkspaceSlug">MAIS workspace slug</label>
      <input
        pInputText
        type="text"
        id="aiWorkspaceSlug"
        [(ngModel)]="aiConfigService.config.workspaceSlug"
        [ngModelOptions]="{ standalone: true }"
        placeholder="e.g. mitel (not set)"
        data-e2e="ai-workspace-slug"
      />
    </div>
    <div class="mi-input-label max-w-md">
      <label for="aiAuthToken">MAIS API key (Settings &gt; API Keys)</label>
      <input
        pInputText
        type="text"
        id="aiAuthToken"
        [(ngModel)]="aiConfigService.config.authToken"
        [ngModelOptions]="{ standalone: true }"
        placeholder="Not set - paste your Generated API Key here"
        data-e2e="ai-auth-token"
      />
    </div>
    <div class="mi-input-label max-w-md">
      <label for="aiMode">MAIS mode</label>
      <input
        pInputText
        type="text"
        id="aiMode"
        [(ngModel)]="aiConfigService.config.mode"
        [ngModelOptions]="{ standalone: true }"
        placeholder="e.g. query (not set)"
        data-e2e="ai-mode"
      />
    </div>
  </div>

  <div class="text-2xl font-bold text-primary mb-4">AI Conversation Options</div>
  <div class="flex flex-col gap-4 mb-8">
    <div class="flex items-start gap-3 max-w-md">
      <p-checkbox
        class="mt-1 shrink-0"
        inputId="aiQuickReplies"
        [binary]="true"
        [(ngModel)]="aiQuickReplies"
        [ngModelOptions]="{ standalone: true }"
        data-e2e="ai-quick-replies-enabled"
      />
      <label for="aiQuickReplies" class="flex flex-col gap-y-1 cursor-pointer">
        <span class="font-semibold text-base">Quick replies</span>
        <span class="text-sm text-muted-color">
          Show the chips the model suggests at the end of a reply. Needs the chip contract in the workspace prompt (see
          DEMO-MAIS-AI-SETUP.md).
        </span>
      </label>
    </div>
    <div class="mi-input-label max-w-md">
      <label for="aiGreetingText">Greeting (markdown, shown when the chat is empty)</label>
      <textarea
        pTextarea
        id="aiGreetingText"
        rows="3"
        [(ngModel)]="aiGreetingText"
        [ngModelOptions]="{ standalone: true }"
        placeholder="Leave empty for no greeting"
        data-e2e="ai-greeting-text"
      ></textarea>
    </div>
    <div class="mi-input-label max-w-md">
      <label for="aiGreetingOptions">Starter chips (one per line, up to 4, 40 characters each)</label>
      <textarea
        pTextarea
        id="aiGreetingOptions"
        rows="4"
        [(ngModel)]="aiGreetingOptions"
        [ngModelOptions]="{ standalone: true }"
        placeholder="Leave empty for no starter chips"
        data-e2e="ai-greeting-options"
      ></textarea>
    </div>
    <div class="mi-input-label max-w-md">
      <label for="aiHandoffLabel">Handoff chip label</label>
      <input
        pInputText
        type="text"
        id="aiHandoffLabel"
        [(ngModel)]="aiHandoffLabel"
        [ngModelOptions]="{ standalone: true }"
        placeholder="Leave empty for no handoff chip"
        data-e2e="ai-handoff-label"
      />
    </div>
  </div>

  <div class="text-2xl font-bold text-primary mb-4">Chat Config Options</div>

  <form class="flex flex-col">
    @for (item of config; track item.name) {
      <div class="flex items-start gap-3 rounded-md px-3 py-3 hover:bg-surface-50 dark:hover:bg-surface-800">
        @if (!item.hideCheckbox) {
          <p-checkbox
            class="mt-1 shrink-0"
            [inputId]="item.name"
            [binary]="true"
            [(ngModel)]="item.value"
            [ngModelOptions]="{ standalone: true }"
          />
          <label [for]="item.name" class="flex flex-col gap-y-1 cursor-pointer">
            <span class="font-semibold text-base">{{ item.display }}</span>
            <span class="text-sm text-muted-color">{{ item.description }}</span>
          </label>
        } @else {
          <div class="flex flex-col gap-y-2 w-full">
            <label [for]="item.name + 'TextField'" class="flex flex-col gap-y-1">
              <span class="font-semibold text-base">{{ item.display }}</span>
              <span class="text-sm text-muted-color">{{ item.description }}</span>
            </label>
            <input
              pInputText
              type="text"
              class="max-w-md"
              [id]="item.name + 'TextField'"
              [(ngModel)]="item.value"
              [ngModelOptions]="{ standalone: true }"
              [placeholder]="item.textFieldPlaceholder"
            />
          </div>
        }
      </div>
    }
  </form>
</div>
